import { render, staticRenderFns } from "./PsiFormMediaUpload.vue?vue&type=template&id=353a4d42&"
import script from "./PsiFormMediaUpload.vue?vue&type=script&lang=js&"
export * from "./PsiFormMediaUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('353a4d42')) {
      api.createRecord('353a4d42', component.options)
    } else {
      api.reload('353a4d42', component.options)
    }
    module.hot.accept("./PsiFormMediaUpload.vue?vue&type=template&id=353a4d42&", function () {
      api.rerender('353a4d42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploads/components/Media/PsiFormMediaUpload.vue"
export default component.exports